import { DocumentCategory } from "../enums/document-category.enum";
import {
  KnowledgeLibraryFilterOptions,
  KnowledgeLibraryItem
} from "../models/knowledge-library.model";

export const knowledgeLibraryItems: KnowledgeLibraryItem[] = [
  {
    id: "1",
    category: DocumentCategory.CIVIL,
    version: "v2.4",
    title: "Compressor Requirement Specification",
    description: "Detailed technical requirements for...",
    tags: ["API 617", "ISO 10438"],
    timeAgo: "1 hours ago",
    views: 5
  },
  {
    id: "2",
    category: DocumentCategory.MECHANICAL,
    version: "v1.1",
    title: "Offshore Compressor Design Standard",
    description: "Baseline engineering standards for...",
    tags: ["ASME VIII"],
    timeAgo: "5 hours ago",
    views: 5
  },
  {
    id: "3",
    category: DocumentCategory.ELECTRICAL,
    version: "v4.0",
    title: "Compressor Maintenance Protocol",
    description: "Step-by-step procedures for...",
    tags: ["Maintenance"],
    timeAgo: "1 hours ago",
    views: 5
  },
  {
    id: "4",
    category: DocumentCategory.INSTRUMENTATION,
    version: "v1",
    title: "P&ID Multi-Stage Compression Unit",
    description: "Piping and Instrumentation...",
    tags: ["Auto CAD", "P&ID"],
    timeAgo: "5 hours ago",
    views: 5
  }
];

export const toTitleCase = (str: string): string =>
  str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const knowledgeLibraryFilterOptions: KnowledgeLibraryFilterOptions = {
  assets: ["Select the Asset", "FPSO", "Expander Compressor"],
  equipmentTypes: [
    "Select the Type",
    "Compressor",
    "Heat Exchanger"
    // "Separator Vessel",
    // "Pump"
  ],
  disciplines: [
    "Select the Discipline",
    "Civil",
    "Mechanical",
    "Electrical",
    "Instrumentation"
  ]
};
